// src/utils/permission.js

/*export const API = process.env.REACT_APP_API_BASE?.replace(/\/+$/, "") ||
                   "https://backend.macustore.com";
const API_V1 = `${API}/api/v1`;

/* 1️⃣ Permissions list cache */
/*export async function loadPermissions(userId) {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  if (user.role_id === "1") {                 // super‑admin
    localStorage.setItem("perms", "[]");
    return [];
  }

  const token = localStorage.getItem("token");
  const res = await fetch(
    `https://backend.macustore.com/api/v1/permission/userpermission/${userId}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  const data = await res.json();

  const slugs = [];
  Object.values(data).forEach((obj) =>
    Object.keys(obj).forEach((s) => slugs.push(s))
  );

  localStorage.setItem("perms", JSON.stringify(slugs));
  return slugs;
}

/* 2️⃣ Permission check */
/*export const hasPerm = (slug) => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  if (String(user.role_id) == "1") return true;

  const list = JSON.parse(localStorage.getItem("perms") || "[]");
  return list.includes(slug);
}; */

import { authFetch } from "../utils/authFetch";

export const API =
  process.env.REACT_APP_API_BASE?.replace(/\/+$/, "") ||
  "https://backend.suvidhape.in";
  // "https://backend.macustore.com";

let lastPermHash = null;

/* Permissions list cache */
export async function loadPermissions(userId, silent = false) {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  if (!userId) return [];

  // super admin
  if (String(user.role_id) === "1") {
    localStorage.setItem("perms", "[]");
    return [];
  }

  const res = await authFetch(
    `/api/v1/permission/userpermission/${userId}`
  );

  if (!res || !res.ok) return [];

  const data = await res.json();

  const slugs = [];
  Object.values(data).forEach(obj => {
    Object.entries(obj).forEach(([slug, val]) => {
      if (val) slugs.push(slug);
    });
  });

  // CHANGE DETECTION
  const hash = JSON.stringify(slugs.sort());

  if (hash !== lastPermHash) {
    lastPermHash = hash;
    localStorage.setItem("perms", JSON.stringify(slugs));

    if (!silent) {
      window.dispatchEvent(new Event("permissions-updated"));
    }
  }

  return slugs;
}

/* Permission check */
export const hasPerm = (slug) => {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  if (String(user.role_id) === "1") return true;

  const list = JSON.parse(localStorage.getItem("perms") || "[]");
  return list.includes(slug);
};

/* 🔥 AUTO RUNTIME SYNC (NO APP.jsx CHANGE NEEDED) */
(function autoPermissionSync() {
  const user = JSON.parse(localStorage.getItem("user") || "{}");
  if (!user?.id) return;

  setInterval(() => {
    loadPermissions(user.id, true);
  }, 5000); // every 5 sec
})();

